import React from 'react';
import { compose, lifecycle, withHandlers } from 'recompose';
import { withRef } from './withRef';

const componentWithRef = (Component) => ({ withRef, ...props }) => (
  <div ref={withRef}>
    <Component {...props} />
  </div>
);

export const withClickOutside = compose(
  withRef(),
  componentWithRef,
  withHandlers({
    onClickOutside: ({ toggled, toggle }) => () => {
      toggled && toggle();
    },
  }),
  withHandlers(() => {
    let _sTouch = false;
    return {
      handleClick: ({ onClickOutside, getRef, toggled }) => (event) => {
        if (!toggled) return;
        if (event.type === 'click' && _sTouch) return;

        if (event.type === 'touchend') _sTouch = true;

        const el = getRef();

        if (el && !el.contains(event.target)) onClickOutside(event);
      },
    };
  }),
  lifecycle({
    componentWillMount() {
      const { handleClick } = this.props;

      document.addEventListener('touchend', handleClick, true);
      document.addEventListener('click', handleClick, true);
    },
    componentWillUnmount() {
      const { handleClick } = this.props;

      document.removeEventListener('touchend', handleClick, true);
      document.removeEventListener('click', handleClick, true);
    },
  })
);
